/* Display original product pixels over the shared reference background. */
window.OukumenPhotos=(()=>{
  const selector='.intro-image>img,.collection-photo>img,.product-photo>img,.category-hero>img,.detail-photo>img,.editorial-photo>img,.gallery-thumbs button>img,.bag-photo>img,.search-photo>img';
  const frames=new WeakMap(),cache=new Map();let initialized=false,cacheBytes=0;
  const cacheLimit=12*1024*1024,entryLimit=32;
  function cachedPrepare(image,cacheKey,sourceKey,options){
    let entry=cache.get(cacheKey);
    if(entry){cache.delete(cacheKey);cache.set(cacheKey,entry);return entry.promise;}
    const scale=Math.min(1,720/Math.max(image.naturalWidth,image.naturalHeight));
    entry={bytes:Math.ceil(image.naturalWidth*scale)*Math.ceil(image.naturalHeight*scale)*4};cache.set(cacheKey,entry);cacheBytes+=entry.bytes;
    entry.promise=prepare(image,sourceKey,options).then(result=>{if(!result?.white&&cache.get(cacheKey)===entry){cacheBytes-=entry.bytes;entry.bytes=0;}return result;});
    while(cache.size>entryLimit||cacheBytes>cacheLimit){const key=cache.keys().next().value,old=cache.get(key);cache.delete(key);cacheBytes-=old.bytes;}
    return entry.promise;
  }
  function layout(width,height){
    if(!(width>0&&height>0))return null;
    const ratio=width/height;
    if(ratio<1){const gap=(1-ratio)*50;return {axis:'horizontal',left:gap,top:0,width:ratio*100,height:100,gap};}
    if(ratio>1){const gap=(1-1/ratio)*50;return {axis:'vertical',left:0,top:gap,width:100,height:100/ratio,gap};}
    return {axis:'none',left:0,top:0,width:100,height:100,gap:0};
  }
  // Only boundary-connected neutral whites are background; enclosed white details stay.
  function matteRGBA(original,width,height,options={}){
    const count=width*height,bright=[],border=[];
    const step=Math.max(1,Math.floor(Math.max(width,height)/180));
    const neutral=(i,minimum)=>{const r=original[i*4],g=original[i*4+1],b=original[i*4+2];return Math.min(r,g,b)>=minimum&&Math.max(r,g,b)-Math.min(r,g,b)<=24;};
    for(let x=0;x<width;x+=step)border.push(x,(height-1)*width+x);
    for(let y=0;y<height;y+=step)border.push(y*width,y*width+width-1);
    for(const i of border)if(neutral(i,options.mode==='white'?210:228))bright.push(i);
    const coverage=bright.length/border.length;
    if(coverage<.22)return {white:false,pixels:original,removed:0,borderCoverage:coverage};
    const median=values=>{values.sort((a,b)=>a-b);return values[Math.floor(values.length/2)];};
    const background=[0,1,2].map(channel=>median(bright.map(i=>original[i*4+channel])));
    const cutoff=Math.max(216,Math.min(248,Math.min(...background)-7));
    const backgroundMinimum=Math.min(...background);
    if(options.mode!=='white'&&backgroundMinimum<242)return {white:false,pixels:original,removed:0,borderCoverage:coverage};
    const brighterForeground=i=>!options.allowBright&&backgroundMinimum<242&&Math.min(original[i*4],original[i*4+1],original[i*4+2])>backgroundMinimum+12;
    const mask=new Uint8Array(count),queue=new Int32Array(count);let head=0,tail=0;
    function protectedPixel(index){
      const polygon=options.protect||[];if(polygon.length<3)return false;
      const x=(index%width)/width,y=Math.floor(index/width)/height;let inside=false;
      for(let i=0,j=polygon.length-1;i<polygon.length;j=i++){
        const [xi,yi]=polygon[i],[xj,yj]=polygon[j];
        if((yi>y)!==(yj>y)&&x<(xj-xi)*(y-yi)/(yj-yi)+xi)inside=!inside;
      }
      return inside;
    }
    function enqueue(i){
      if(mask[i]||!neutral(i,cutoff)||protectedPixel(i)||brighterForeground(i))return;
      const offset=i*4;
      const distance=options.mode==='white'?36:24;
      if(Math.abs(background[0]-original[offset])>distance||Math.abs(background[1]-original[offset+1])>distance||Math.abs(background[2]-original[offset+2])>distance)return;
      mask[i]=1;queue[tail++]=i;
    }
    for(let x=0;x<width;x++){if(x<width*.06||x>width*.94)enqueue(x);enqueue((height-1)*width+x);}
    for(let y=0;y<height;y++){enqueue(y*width);enqueue(y*width+width-1);}
    while(head<tail){const i=queue[head++],x=i%width;if(x>0)enqueue(i-1);if(x<width-1)enqueue(i+1);if(i>=width)enqueue(i-width);if(i<count-width)enqueue(i+width);}
    const fraction=tail/count;
    if(fraction<(options.mode==='white'?.005:.12)||fraction>.86)return {white:false,pixels:original,removed:tail,borderCoverage:coverage,review:fraction>.86};
    const pixels=new Uint8ClampedArray(original);
    for(let i=0;i<count;i++){
      if(mask[i]){pixels[i*4+3]=0;continue;}
      const x=i%width;
      const edge=(x>0&&mask[i-1])||(x<width-1&&mask[i+1])||(i>=width&&mask[i-width])||(i<count-width&&mask[i+width]);
      if(edge&&neutral(i,210)&&!protectedPixel(i)&&!brighterForeground(i)){
        const minimum=Math.min(original[i*4],original[i*4+1],original[i*4+2]);
        pixels[i*4+3]=Math.round(original[i*4+3]*Math.min(1,Math.max(.15,(Math.min(...background)-minimum)/50)));
      }
    }
    return {white:true,pixels,removed:tail,borderCoverage:coverage};
  }
  function readable(source,options){
    const scale=Math.min(1,720/Math.max(source.naturalWidth,source.naturalHeight));
    const canvas=document.createElement('canvas');canvas.width=Math.max(1,Math.round(source.naturalWidth*scale));canvas.height=Math.max(1,Math.round(source.naturalHeight*scale));
    const context=canvas.getContext('2d',{willReadFrequently:true});context.drawImage(source,0,0,canvas.width,canvas.height);
    const pixels=context.getImageData(0,0,canvas.width,canvas.height),result=matteRGBA(pixels.data,canvas.width,canvas.height,options);
    if(result.white){pixels.data.set(result.pixels);context.putImageData(pixels,0,0);}
    return result.white?{white:true,canvas}:{white:false,review:result.review};
  }
  async function prepare(image,key,options){
    await new Promise(resolve=>setTimeout(resolve,0));
    try{return readable(image,options);}catch{
      // Remote color images are read only when their host permits CORS.
      if(!/^https?:/i.test(key)||typeof Image==='undefined')return null;
      try{
        const allowed=new Image();allowed.crossOrigin='anonymous';
        await new Promise((resolve,reject)=>{allowed.onload=resolve;allowed.onerror=reject;allowed.src=key;});
        return readable(allowed,options);
      }catch{return null;}
    }
  }
  async function refresh(image){
    // This opaque square overlay has no frame state and never changes the default fill.
    if(image.dataset?.photoRole==='hover-white')return;
    if(!image.matches?.(selector)||!layout(image.naturalWidth,image.naturalHeight))return;
    const frame=image.parentElement;if(!frame)return;
    frame.classList.add('photo-auto-frame','has-wall-background');frame.dataset.photoFit='complete';
    let record=frames.get(image);
    if(!record){record={canvas:null,key:null};frames.set(image,record);}
    // The shared wall fills contain gaps; a sampled color creates visible side bars.
    // The original opaque photo and every garment pixel remain intact above it.
    image.style.background='transparent';
    const key=image.currentSrc||image.src,mode=image.dataset.backgroundMode||'auto',signature=key+'|'+mode+'|'+(image.dataset.photoProtect||'');
    if(record.key===signature)return;
    record.key=signature;record.canvas?.remove();record.canvas=null;
    image.classList.remove('background-matted');
    frame.dataset.backgroundStyle='reference-wall-padding';
    // Main covers already contain their background: no canvas or delayed replacement.
    if(mode==='original'||mode==='baked'){if(mode==='baked')frame.dataset.backgroundStyle='reference-wall-baked';return;}
    if(mode==='cutout'){frame.classList.add('has-wall-background');frame.dataset.backgroundStyle='reference-wall-cutout';return;}
    let protect=[],allowBright=false;try{const meta=JSON.parse(image.dataset.photoProtect||'[]');protect=Array.isArray(meta)?meta:meta.polygon||[];allowBright=Boolean(meta.allowBright);}catch{}
    const result=await cachedPrepare(image,signature,key,{mode,protect,allowBright});
    if(record.key!==signature||(image.currentSrc||image.src)!==key)return;
    if(!result?.white){frame.dataset.backgroundStyle=result?.review?'needs-review':'reference-wall-padding';return;}
    const canvas=document.createElement('canvas');canvas.className='product-cutout';canvas.setAttribute('aria-hidden','true');canvas.width=result.canvas.width;canvas.height=result.canvas.height;canvas.getContext('2d').drawImage(result.canvas,0,0);
    const fit=layout(canvas.width,canvas.height);Object.assign(canvas.style,{left:`${fit.left}%`,top:`${fit.top}%`,width:`${fit.width}%`,height:`${fit.height}%`,right:'auto',bottom:'auto'});
    frame.insertBefore(canvas,image);record.canvas=canvas;
    frame.classList.add('has-wall-background');image.classList.add('background-matted');frame.dataset.backgroundStyle='reference-wall';
  }
  function scan(root=document){
    if(root.matches?.(selector)&&root.complete)refresh(root);
    root.querySelectorAll?.(selector).forEach(image=>{if(image.complete)refresh(image);});
  }

  function requestHover(frame){
    const image=frame?.querySelector('.photo-hover-white');if(!image?.dataset.hoverSrc)return;
    image.loading='eager';if(image.dataset.hoverSrcset)image.srcset=image.dataset.hoverSrcset;
    image.src=image.dataset.hoverSrc;delete image.dataset.hoverSrc;delete image.dataset.hoverSrcset;
  }
  function hoverFrame(target){
    const scope=target?.closest?.('.product,.collection-card,.search-result');
    return scope?.querySelector('.has-hover-white')||target?.closest?.('.has-hover-white');
  }
  function initialize(root=document){
    if(!initialized){
      initialized=true;
      document.addEventListener('load',event=>{if(event.target.dataset?.photoRole==='hover-white'){event.target.dataset.ready='true';return;}refresh(event.target);},true);
      document.addEventListener('pointerover',event=>{if(event.pointerType!=='touch'&&matchMedia('(hover:hover) and (pointer:fine)').matches)requestHover(hoverFrame(event.target));},{passive:true});
      document.addEventListener('focusin',event=>{if(event.target.matches?.(':focus-visible'))requestHover(hoverFrame(event.target));});
      if(typeof MutationObserver!=='undefined')new MutationObserver(records=>records.forEach(record=>record.addedNodes.forEach(scan))).observe(document.body,{childList:true,subtree:true});
    }
    scan(root);
  }
  return {initialize,refresh,layout,matteRGBA,requestHover,cacheStats:()=>({entries:cache.size,estimatedBytes:cacheBytes,limitBytes:cacheLimit})};
})();
